import { bind, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { addEventListener } from '../../facades/document';
import window from 'window-or-global';
import tipsy from './thirdpartycode/tipsy';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function removePropertyPanelTips() {
	$('.tipsy').remove();
}

function keyboardshortcutsHandler() {
	const replacePlus = /\+/g;
	// Defer to ensure shortcut code has had a chance to update the title on the save-bar buttons
	setTimeout(() => {
		$('#rte-savebar .aui-button[title]').each(function () {
			const trigger = $(this);
			let tooltip = trigger.attr('title');
			trigger.removeAttr('title');
			if (window.tinymce.Env.mac) {
				// Remove + from shortcut text for Mac
				const scIdx = tooltip.indexOf('(');
				if (scIdx >= 0) {
					tooltip = tooltip.substr(0, scIdx) + tooltip.substr(scIdx).replace(replacePlus, '');
				}
			}
			trigger.attr('data-tooltip', tooltip);
		});
	}, 0);
}

export function initChunkyTips() {
	if (process.env.NODE_ENV !== 'production') {
		console.debug('Enabling Chunky Tooltip for the editor');
	}

	tipsy($);

	function tooltipExtractor() {
		// handle missing tooltip for buttons without a tooltip
		return $(this).attr('data-tooltip') || '';
	}

	const defaultOptions = {
		live: true, // Created links are handled automatically
		gravity: 'n', // Point the arrow to the top
		title: tooltipExtractor,
		delayIn: 250,
		delayOut: 0, // Can be removed once AUI-1214 is resolved
	};

	const tooltipBelowPreferredFn = $.fn.tipsy.autoBounds2(50, 'n');
	const tooltipRightPreferredFn = $.fn.tipsy.autoBounds2(50, 'w');

	const tooltipDefaultBelowOptions = $.extend({}, defaultOptions, {
		gravity: tooltipBelowPreferredFn,
	});
	const tooltipDefaultToRightOptions = $.extend({}, defaultOptions, {
		gravity: tooltipRightPreferredFn,
	});
	/**
	 * CONFDEV-49897
	 * Once AUI is upgraded, we might come back to use variable 'tooltipDefaultAboveOptions'
	 */
	const tooltipDefaultForceRightOptions = $.extend({}, defaultOptions, {
		gravity: 'se',
	});

	$('#rte-toolbar [data-tooltip]:not(.dropdown-item)').tooltip(tooltipDefaultBelowOptions);
	$('#rte-toolbar .dropdown-item[data-tooltip]').tooltip(tooltipDefaultToRightOptions);
	$('#rte-savebar [data-tooltip]').tooltip(tooltipDefaultForceRightOptions);
	$('#editor-precursor [data-tooltip]').tooltip(tooltipDefaultBelowOptions);
	$('#property-panel [data-tooltip]').tooltip(tooltipDefaultBelowOptions);

	// Remove tooltips if a dropdown is shown or hidden:
	function removeDropdownTooltips(e, type, obj) {
		if (type === 'dropdown') {
			$('.tipsy').remove();
			if (obj && obj.trigger && obj.trigger.jquery) {
				const tipsyData = obj.trigger.data('tipsy');
				if (tipsyData) {
					tipsyData.hoverState = 'out';
				}
			}
		}
	}

	// TODO: memory leak candidate, we need an spa lifecycle to manage teardowns.
	addEventListener('showLayer', removeDropdownTooltips);
	addEventListener('hideLayer', removeDropdownTooltips);

	bind('created.property-panel', removePropertyPanelTips);
	bind('destroyed.property-panel', removePropertyPanelTips);
	bind('register-contexts.keyboardshortcuts', keyboardshortcutsHandler);
}

export function cleanupChunkyTips() {
	unbind('created.property-panel', removePropertyPanelTips);
	unbind('destroyed.property-panel', removePropertyPanelTips);
	unbind('register-contexts.keyboardshortcuts', keyboardshortcutsHandler);
}
